import { debounce, once } from 'lodash';
import { useEffectOnce } from './use-effect-once';

export const useScrollTo = once(() => {
  const performScroll = (identifier: string) => {
    const element = document.getElementById(identifier);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'end',
      });
    }
  };

  const debouncedPerformScroll = debounce(performScroll, 100);

  const scrollToElement = (identifier: string) => {
    debouncedPerformScroll(identifier);
  };

  return scrollToElement;
});

export function useScrollIntoViewOnMount(identifier: string) {
  const scrollTo = useScrollTo();

  useEffectOnce(() => {
    scrollTo(identifier);
  });
}